import { render, staticRenderFns } from "./tags-list.vue?vue&type=template&id=85594a56&scoped=true"
import script from "./tags-list.vue?vue&type=script&lang=js"
export * from "./tags-list.vue?vue&type=script&lang=js"
import style0 from "./tags-list.vue?vue&type=style&index=0&id=85594a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85594a56",
  null
  
)

export default component.exports